import NotPermissions from './NotPermissions';

export default NotPermissions;
